import axios from "axios";
import { MARKETPLACE, PALLET_MARKETPLACE, LISTING_PAGE_COUNT } from "../config";
import arweaveKey from "../config/arweave.json";
import Arweave from "arweave";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import randomstring from "randomstring";

const arweave = Arweave.init({
  host: "arweave.net",
  port: 443,
  protocol: "https",
});

export const approveHandle = async (
  signingClient,
  nftContract,
  senderAddress,
  data
) => {
  try {
    console.log("approveHandle..", data);
    // Define gas price and limit
    const fee = {
      amount: [{ amount: "10000", denom: "usei" }],
      gas: "300000",
    };

    // Build message content
    const msg = {
      approve: {
        spender: MARKETPLACE,
        token_id: `${data?.token_id}`,
      },
    };

    // Call smart contract execute msg
    const tx = await signingClient?.execute(
      senderAddress,
      nftContract,
      msg,
      fee
    );
    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const listHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("listing..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    // Build message content
    const msg = {
      list_tokens: {
        tokens: [
          {
            owner: senderAddress,
            id: `${collection}-${data?.token_id}`,
            price: data?.price?.toString(),
            on_sale: true,
          },
        ],
      },
    };

    const approve_msg = {
      approve: {
        spender: MARKETPLACE,
        token_id: `${data?.token_id}`,
      },
    };

    const transfer_msg = {
      transfer_nft: {
        recipient: MARKETPLACE,
        token_id: `${data?.token_id}`
      }
    }

    const instructions = [];
    instructions.push({ contractAddress: collection, msg: approve_msg }); // approve
    // list
    instructions.push({ contractAddress: MARKETPLACE, msg: msg }); 
    // transfer
    instructions.push({ contractAddress: collection, msg: transfer_msg }); 

    console.log("instructions: ", instructions);

    const tx = await signingClient?.executeMultiple(
      senderAddress,
      instructions,
      fee
    );

    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const unlistHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("delisting..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    // Build message content
    const msg = {
      delist_tokens: {
        tokens: [`${collection}-${data?.token_id}`],
      },
    };

    const transfer_msg = {
      transfer_nft: {
        recipient: senderAddress,
        address: collection,
        token_id: data.token_id
      }
    }

    console.log("msg: ", msg);

    const instructions = [];

    instructions.push({ contractAddress: MARKETPLACE, msg: transfer_msg})
    instructions.push({ contractAddress: MARKETPLACE, msg: msg }); // delist

    // Call smart contract execute msg
    // const tx = await signingClient?.execute(
    //   senderAddress,
    //   MARKETPLACE,
    //   msg,
    //   fee
    // );
    const tx = await signingClient?.executeMultiple(
      senderAddress,
      instructions,
      fee
    );
    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const updatePriceHandle = async (signingClient, senderAddress, data) => {
  try {
    // await makeBidHandle(signingClient, senderAddress, data);
    // await unMakeBidHandle(signingClient, senderAddress, data);
    // await acceptBidHandle(signingClient, senderAddress, data);
    // return
    console.log("updatePriceHandle..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    // Build message content
    const msg = {
      update_price: {
        token: `${collection}-${data?.token_id}`,
        price: data?.price?.toString(),
      },
    };
    console.log("msg: ", msg);

    // Call smart contract execute msg
    const tx = await signingClient?.execute(
      senderAddress,
      MARKETPLACE,
      msg,
      fee
    );
    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const buyHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("buyHandle..", data, senderAddress);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    const funds = [
      {
        denom: "usei",
        amount: `${data?.price}`,
      },
    ];

    // Build message content
    const msg = {
      buy: {
        token_id: `${data?.collection}-${data?.token_id}`,
        contract_addr: `${data?.collection}`,
      },
    };

    const memo = "buy";
    console.log("buy:", data, msg, funds);
    // Call smart contract execute msg
    const tx = await signingClient?.execute(
      senderAddress,
      MARKETPLACE,
      msg,
      fee,
      memo,
      funds
    );
    console.log("tx: ", tx);

    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const buyPalletHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("buyPalletHandle..", data, senderAddress);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "5000000",
    };

    const funds = [
      {
        denom: "usei",
        amount: `${Number(data?.price) * 1.02}`,
      },
    ];

    // Build message content
    const msg = {
      buy_now: {
        expected_price: {
          amount: `${data?.price}`,
          denom: "usei",
        },
        nft: {
          address: `${data?.collection_key}`,
          token_id: `${data?.id}`,
        },
      },
    };

    const memo = "buy";
    console.log("pallet buy via nut:", data, msg, funds);
    // Call smart contract execute msg
    const tx = await signingClient?.execute(
      senderAddress,
      PALLET_MARKETPLACE,
      msg,
      fee,
      memo,
      funds
    );
    console.log("tx: ", tx);

    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const cartBuyHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("buyHandle..", data, senderAddress);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "500000", denom: "usei" }],
      gas: "10000000",
    };

    const instructions = [];
    for (let i = 0; i < data.length; i++) {
      // Build message content

      if (data[i]?.marketplace == "pallet") {
        const funds = [
          {
            denom: "usei",
            amount: `${Number(data[i]?.price) * 1.02}`,
          },
        ];
        // Build message content
        const msg = {
          buy_now: {
            expected_price: {
              amount: `${data[i]?.price}`,
              denom: "usei",
            },
            nft: {
              address: `${data[i]?.collection_key}`,
              token_id: `${data[i]?.id}`,
            },
          },
        };
        instructions.push({
          contractAddress: PALLET_MARKETPLACE,
          msg: msg,
          funds: funds,
        }); // approve
      } else {
        const funds = [
          {
            denom: "usei",
            amount: `${data[i]?.price}`,
          },
        ];
        const msg = {
          buy: {
            token_id: `${data[i]?.collection}-${data[i]?.token_id}`,
            contract_addr: `${data[i]?.collection}`,
          },
        };
        instructions.push({
          contractAddress: MARKETPLACE,
          msg: msg,
          funds: funds,
        }); // approve
      }
    }

    console.log("instructions: ", instructions);

    const tx = await signingClient?.executeMultiple(
      senderAddress,
      instructions,
      fee
    );

    console.log("tx: ", tx);

    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const makeBidHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("biding..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    if (!collection) {
      collection = data?.collection;
    }

    const funds = [
      {
        denom: "usei",
        amount: `${data?.price}`,
      },
    ];

    const msg = {
      make_bid: {
        bid: {
          owner: senderAddress,
          id: `${collection}-${data?.token_id}-${senderAddress}`,
          price: data?.price?.toString(),
        },
      },
    };

    const memo = "makeBid";

    console.log("msg: ", msg, funds);

    // Call smart contract execute msg
    const tx = await signingClient?.execute(
      senderAddress,
      MARKETPLACE,
      msg,
      fee,
      memo,
      funds
    );

    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const unMakeBidHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("unbid..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    if (!collection) {
      collection = data?.collection;
    }

    // Build message content
    const msg = {
      un_make_bid: {
        bid_id: `${collection}-${data?.token_id}-${senderAddress}`,
      },
    };

    console.log("unbid msg:", msg);

    const tx = await signingClient?.execute(
      senderAddress,
      MARKETPLACE,
      msg,
      fee
    );

    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const updateBidHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("updatebid..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    if (!collection) {
      collection = data?.collection;
    }

    // Build message content
    const msg = {
      update_bid: {
        bid_id: `${collection}-${data?.token_id}`,
      },
    };

    console.log("update bid msg:", msg);

    const tx = await signingClient?.execute(
      senderAddress,
      MARKETPLACE,
      msg,
      fee
    );

    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const acceptBidHandle = async (signingClient, senderAddress, data) => {
  try {
    console.log("acceptBid..", data);

    // Define gas price and limit
    const fee = {
      amount: [{ amount: "100000", denom: "usei" }],
      gas: "1000000",
    };

    let collection = data?.contract;
    if (data?.filter) {
      collection = data?.collection;
    }

    if (!collection) {
      collection = data?.collection;
    }

    // Build message content
    const msg = {
      accept_bid: {
        bid_id: `${collection}-${data?.token_id}`,
      },
    };

    console.log("acceptBid msg:", msg);

    const tx = await signingClient?.execute(
      senderAddress,
      MARKETPLACE,
      msg,
      fee
    );

    console.log("tx: ", tx);
    return { tx, success: true };
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const getNftCountInCollection = async (
  wasmClient,
  collectionAddress
) => {
  try {
    // Create the query msg json
    const queryMsg = {
      num_tokens: {},
    };

    // Query a smart contract state
    const queryResponse = await wasmClient.queryContractSmart(
      collectionAddress,
      queryMsg
    );

    return queryResponse.count;
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const getCollectionNfts = async (NFT_CONTRACT, wasmClient, startAfter) => {
  let palletData = [];
  let lastId = "";

  try {
    // Create the query msg json
    const queryMsg = {
      tokens: {
        owner: "sei152u2u0lqc27428cuf8dx48k8saua74m6nql5kgvsu4rfeqm547rsnhy4y9",
        limit: 10, // because of noprice nft 
        start_after: startAfter.toString(),
      },
    };

    // Query a smart contract state
    const queryResponse = await wasmClient.queryContractSmart(
      NFT_CONTRACT,
      queryMsg
    );
    console.log(`all nft data display -> ${queryResponse}`);

    console.log('query reponse = ', queryResponse.tokens)

    const mappedArray = await Promise.all(
      queryResponse.tokens.map(async (item) => {
        try {
          // Create the query msg json
          const queryMsg = {
            nft_info: {
              token_id: item,
            },
          };

          const priceMsg = {
            nft: {
              address: NFT_CONTRACT,
              token_id: item,
            },
          };

          // Query a smart contract state
          const queryResponse = await wasmClient.queryContractSmart(
            NFT_CONTRACT,
            queryMsg
          );
          const url = queryResponse.token_uri;
          const metadataResposne = await axios.get(url);

          const priceQueryResponse = await wasmClient.queryContractSmart(
            "sei152u2u0lqc27428cuf8dx48k8saua74m6nql5kgvsu4rfeqm547rsnhy4y9",
            priceMsg
          );

          // console.log(priceQueryResponse?.auction?.prices);
          const price = priceQueryResponse?.auction?.prices[0]?.amount || null
          const token_id = metadataResposne?.data?.edition || metadataResposne?.data?.tokenId || metadataResposne?.data?.id || metadataResposne?.data?.Id || ""
          const traits = metadataResposne?.data?.attributes || metadataResposne?.data?.traits || metadataResposne?.data?.property || {}

          palletData.push({
            token_id,
            image: metadataResposne.data.image,
            title: metadataResposne.data.name,
            description: metadataResposne?.data?.description || "",
            traits,
            price,
            filter: true,
            marketplace: "pallet",
            collection_key: NFT_CONTRACT,
            id: token_id
          });
        } catch (error) {
          console.log(error);
          return { message: error, success: false };
        }
      })
    );

    lastId = palletData[palletData.length - 1].token_id
    console.log('all nfts = ', palletData, lastId)
    return {palletData, lastId};
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const getAllNftsInCollection = async (
  wasmClient,
  collectionAddress,
  page,
  imageUrl,
  name
) => {
  try {
    const queryMsg = {
      nft_info: {
        token_id: "1",
      },
    };

    let result = [];
    console.log(imageUrl)
    if (imageUrl && name) {
      for (
        let i = (page - 1) * LISTING_PAGE_COUNT + 1;
        i <= page * LISTING_PAGE_COUNT;
        i++
      ) {
        result.push({
          image:
            imageUrl.replace(/\/[^/]+$/, "/") +
            i +
            "." +
            imageUrl.split(".").pop(),
          name: name.replace(/\d+$/, "") + i,
          id: i.toString(),
        });
        console.log(i, "===result===", result)
      }
    } else {
      const queryResponse = await wasmClient.queryContractSmart(
        collectionAddress,
        queryMsg
      );
      console.log("queryRes--->>>", queryResponse)
      const fullUrl = queryResponse?.token_uri || "";
      console.log("full url = ", fullUrl);

      const metadataResposne = await axios.get(fullUrl);
      const imageUrl = metadataResposne.data.image;
      const name = metadataResposne.data.name;
      console.log("name::::", name)

      for (
        let i = (page - 1) * LISTING_PAGE_COUNT + 1;
        i <= page * LISTING_PAGE_COUNT;
        i++
      ) {
        result.push({
          image:
            imageUrl.replace(/\/[^/]+$/, "/") +
            i +
            "." +
            imageUrl.split(".").pop(),
          name: name.replace(/\d+$/, "") + i,
          id: i.toString(),
        });
      }
    }

    return result;
  } catch (error) {
    console.log(error);
    return { message: error, success: false };
  }
};

export const uploadFileToArweave = async (fileData) => {
  return new Promise((resolve, reject) => {
    console.log("upload file to arweave");
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const fData = e.target.result;
        const transaction = await arweave.createTransaction(
          { data: fData },
          arweaveKey
        );
        await arweave.transactions.sign(transaction, arweaveKey);
        const uploader = await arweave.transactions.getUploader(transaction);

        while (!uploader.isComplete) {
          await uploader.uploadChunk();
          console.log(
            `${uploader.pctComplete}% complete, ${uploader.uploadedChunks}/${uploader.totalChunks}`
          );
        }

        console.log("transaction ID", transaction.id);
        console.log(
          `File successfully uploaded: https://arweave.net/${transaction.id}`
        );
        resolve(transaction.id);
      } catch (err) {
        reject("Can't upload file!");
      }
    };
    reader.readAsArrayBuffer(fileData);
  });
};

export const uploadJsonToArweave = async (jsonData) => {
  try {
    const transaction = await arweave.createTransaction(
      { data: JSON.stringify(jsonData) },
      arweaveKey
    );
    transaction.addTag("Content-Type", "application/json");
    await arweave.transactions.sign(transaction, arweaveKey);
    const uploader = await arweave.transactions.getUploader(transaction);

    while (!uploader.isComplete) {
      await uploader.uploadChunk();
      console.log(
        `${uploader.pctComplete}% complete, ${uploader.uploadedChunks}/${uploader.totalChunks}`
      );
    }

    console.log("transaction ID", transaction.id);
    console.log(
      `File successfully uploaded: https://arweave.net/${transaction.id}`
    );
    return `https://arweave.net/${transaction.id}`;
  } catch (err) {
    console.log("json upload err ", err);
    throw err;
  }
};

export const mintNft = async (
  signingCosmWasmClient,
  tokenUri,
  tokenId,
  owner,
  contract
) => {
  try {
    console.log("signing cosm wasm = ", signingCosmWasmClient);
    console.log("token uri, token id = ", tokenUri, tokenId);
    const fee = {
      amount: [{ amount: "150000", denom: "usei" }],
      gas: "1500000",
    };

    const msg = {
      mint: {
        token_id: tokenId,
        owner,
        token_uri: tokenUri,
      },
    };

    const result = await signingCosmWasmClient.execute(
      owner,
      contract,
      msg,
      fee
    );
    console.log("mint result = ", result);
    return result;
  } catch (err) {
    console.log("mint nft err ", err);
    throw err;
  }
};

export const createCollection = async (
  signingCosmWasmClient,
  owner,
  name,
  symbol
) => {
  const code_id = 1336;
  const instantiateMsg = {
    // instantiate: {
    // admin: owner,
    // code_id, // This should be the code ID of the CW721 base contract
    // label: "NFT Collection Label",
    // msg: {
    // This should match the expected schema of the CW721InstantiateMsg
    name,
    symbol,
    minter: owner,
    // Add other fields required by your CW721 base contract instantiation message
    // }
    // }
  };

  const senderAddress = owner;
  const contractInstantiateMsg = instantiateMsg; // The message prepared in the previous step
  const fee = {
    amount: [{ amount: "150000", denom: "usei" }],
    gas: "1500000",
  };

  try {
    const result = await signingCosmWasmClient.instantiate(
      senderAddress,
      code_id,
      contractInstantiateMsg,
      "NFT Collection",
      fee
    );
    console.log(result);
    return result.contractAddress;
  } catch (err) {
    console.log("create collection err ", err);
    throw err;
  }
};

export const getCollectionCount = async (cosmWasmClient, collection) => {
  try {
    const msg = {
      num_tokens: {},
    };

    const queryResponse = await cosmWasmClient.queryContractSmart(
      collection,
      msg
    );
    console.log("query response = ", queryResponse);
    return queryResponse.count;
  } catch (err) {
    console.log("get collection count err", err);
    throw err;
  }
};

export const getNftDetail = async (cosmWasmClient, collection, token_id) => {
  try {
    const queryMsg = {
      nft_info: {
        token_id: token_id
      }
    }
    const queryResponse = await cosmWasmClient.queryContractSmart(collection, queryMsg);
    const metadataResposne = await axios.get(queryResponse.token_uri)
    console.log('meta data = ', metadataResposne.data)

    const queryMsg1 = {
      nft: {
        address: collection,
        token_id: token_id
      }
    }
    const nftData = await cosmWasmClient.queryContractSmart(PALLET_MARKETPLACE, queryMsg1)
    console.log('nft data = ', nftData)

    // const lTime = new Date(nftData?.auction?.created_at)
    // const exTime = new Date(nftData?.auction?.expiration_time)

    const detailData = {
      collection,
      currency: "SEI",
      expiration: nftData?.auction?.expiration_time,
      listing_time: nftData?.auction?.created_at,
      metadata: metadataResposne.data,
      price: nftData?.auction?.prices[0]?.amount || 0,
      seller: nftData?.owner,
      token_id: nftData?.nft_token_id,
      name: nftData?.nft_info.name,
      symbol: nftData?.nft_info.symbol,
    }

    return detailData
  } catch (err) {
    console.log('get nft detail err', err)
    throw err
  }
}

const s3Client = new S3Client({
  region: process.env.NEXT_PUBLIC_SES_REGION, // e.g., us-west-2
  credentials: {
    accessKeyId: process.env.NEXT_PUBLIC_AWS_ACCESS_KEY_ID, // Not recommended for production
    secretAccessKey: process.env.NEXT_PUBLIC_AWS_SECRET_ACCESS_KEY, // Not recommended for production
  },
});
export const uploadFileToS3 = async (file) => {
  const keyName = randomstring.generate() + "." + file.name.split(".").pop();

  const uploadParams = {
    Bucket: "nutmarket",
    Key: keyName,
    Body: file,
  };

  try {
    await s3Client.send(new PutObjectCommand(uploadParams));
    const url = `https://nutmarket.s3.amazonaws.com/${keyName}`;
    console.log("Success uploaded file ", url);
    return url;
  } catch (err) {
    console.log("file upload error", err);
    throw err;
  }
};
